import axios from "../axios";

const BASE_URL = "/organization-questionnaires";

const api = {

    // CATEGORY 1
    updatePurchasedGoodsAndServices({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.patch(`${BASE_URL}/${questionnaireId}/purchased-goods-and-services`, data, headers).then(({data}) => data);
    },

    // CATEGORY 2

    // CATEGORY 4
    updateUpstreamTransportationAndDistribution({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.patch(`${BASE_URL}/${questionnaireId}/upstream-transportation-distribution`,
          data, headers).then(({ data }) => data);
    },

    // CATEGORY 5
    updateWasteGeneratedInOperations({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.patch(`${BASE_URL}/${questionnaireId}/waste-generated-in-operations`, data, headers).then(({ data }) => data);
    },

    // CATEGORY 6
    updateBusinessTravel({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.patch(`${BASE_URL}/${questionnaireId}/business-travel`, data, headers).then(({data}) => data);
    },
    // CATEGORY 7
    updateEmployeeCommuting({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.patch(`${BASE_URL}/${questionnaireId}/employee-commuting`, data, headers).then(({data}) => data);
    },

    // CATEGORY 8
    createUpstreamLeasedAssets({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.post(`${BASE_URL}/${questionnaireId}/upstream-leased-assets`, data, headers).then(({data}) => data);
    },
    updateUpstreamLeasedAsssets({ questionnaireId, id, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.put(`${BASE_URL}/${questionnaireId}/upstream-leased-assets/${id}`, data, headers).then(({data}) => data);
    },
    // CATEGORY 9
    updateDownstreamTransportationDistribution({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.patch(`${BASE_URL}/${questionnaireId}/downstream-transportation-distribution`, data, headers).then(({data}) => data);
    },

    // CATEGORY 10
    createProcessingOfSoldProducts({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.post(`${BASE_URL}/${questionnaireId}/processing-of-sold-products`, data, headers).then(({data}) => data);
    },
    updateProcessingOfSoldProducts({ questionnaireId, id, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.put(`${BASE_URL}/${questionnaireId}/processing-of-sold-products/${id}`, data, headers).then(({data}) => data);
    },
    // CATEGORY 12
    updateTreatmentOfSoldProducts({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.patch(`${BASE_URL}/${questionnaireId}/treatment-of-sold-products`, data, headers).then(({ data }) => data);
    },

    // CATEGORY 13
    createDownstreamLeasedAssets({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.post(`${BASE_URL}/${questionnaireId}/downstream-leased-assets`, data, headers).then(({data}) => data);
    },
    updateDownstreamLeasedAssets({ questionnaireId, id, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.put(`${BASE_URL}/${questionnaireId}/downstream-leased-assets/${id}`, data, headers).then(({data}) => data);
    },
    // CATEGORY 14
    createFranchises({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.post(`${BASE_URL}/${questionnaireId}/franchises`, data, headers).then(({data}) => data);
    },
    updateFranchises({ questionnaireId, id, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.put(`${BASE_URL}/${questionnaireId}/franchises/${id}`, data, headers).then(({data}) => data);
    },
    // CATEGORY 15
    createInvestments({ questionnaireId, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.post(`${BASE_URL}/${questionnaireId}/investments`, data, headers).then(({data}) => data);
    },
    updateInvestments({ questionnaireId, id, data }, accessToken) {
        const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
        return axios.put(`${BASE_URL}/${questionnaireId}/investments/${id}`, data, headers).then(({data}) => data);
    },
};



export default api;
